var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6329 11.2816L11.675 9.32371C10.9758 8.62447 9.7871 8.90419 9.50741 9.81317C9.29764 10.4425 8.5984 10.7921 7.96909 10.6523C6.57063 10.3026 4.6827 8.48463 4.33308 7.01624C4.12331 6.3869 4.54285 5.68767 5.17216 5.47792C6.08116 5.19823 6.36086 4.00954 5.66162 3.3103L3.70377 1.35245C3.14439 0.862986 2.30531 0.862986 1.81584 1.35245L0.4873 2.68099C-0.841242 4.07946 0.627147 7.78539 3.91354 11.0718C7.19994 14.3582 10.9059 15.8965 12.3043 14.498L13.6329 13.1695C14.1224 12.6101 14.1224 11.771 13.6329 11.2816Z",
    fill: "#1E1B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3561abac5c844f7f34608533eb059eb4.svg";
export { ForwardRef as ReactComponent };